import Vue from 'vue'
import HomefitStory from '@/HomefitStoryV2'
import LoadScript from 'vue-plugin-load-script';
Vue.use(LoadScript);
Vue.config.productionTip = false;
new Vue({
  render: h => h(HomefitStory)
}).$mount('#app')